export const getElementsWithLightbox = (parentElement) => {
    // get elements the lightbox extension is bind to and exclude the ones that are redirecting to an article
    return Array.from(parentElement.querySelectorAll('.lightbox > img, a.image:not(.link-internal) > img'));
};
